import React, { ReactNode } from "react";
import { Paper, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		maxWidth: 1500,
		padding: theme.spacing(2),
		margin: "auto",
		[theme.breakpoints.up("md")]: {
			padding: theme.spacing(3),
		},
	},
}));
interface MyPagePaperProps {
	noRoot?: boolean;
	className?: string;
	children?: ReactNode;
	style?: object;
}
export const MyPagePaper = (props: MyPagePaperProps) => {
	const { className, children, noRoot = false, ...rest } = props;
	const classes = useStyles();
	return (
		<div className={className}>
			<Paper
				elevation={5}
				{...rest}
				className={noRoot ? undefined : classes.root}
			>
				{children}
			</Paper>
		</div>
	);
};
